import React from 'react'

const Data = () => {
    return (
        <div>
          <div className='container'>
            <h1>Data Types</h1>
            <p>Data types in C refer to an extensive system used for declaring 
                variables or functions of different types. The type of a variable
                 determines how much space it occupies in storage size and how the bit pattern
                  stored is interpreted.</p><br /> <br />
                  <p>The types in C can be classified as follows −</p>
                  <table>
  <caption>Data Types</caption>
  <thead>
    <tr>
      <th scope="col">SR.NO</th>
      <th scope="col">Description</th>
      
    </tr>
  </thead>
  <tbody>
    <tr>
      <td data-label="SR. NO">1</td>
      <td data-label="Description"><h4>Basic Types</h4> <br />
      <p>
      They are arithmetic types and are further classified into: (a) integer types and (b) floating-point types.</p> </td>
    
    </tr>
    <tr>
      <td scope="row" data-label="SR. NO">2 </td>
      <td data-label="Symbol"> <h4>Enumerated types</h4> <br /><p>They are again arithmetic types and they are used to define variables that can only assign certain discrete integer values throughout the program.</p></td>
    
    </tr>
    <tr>
      <td scope="row" data-label="SR. NO">3</td>
      <td data-label="Symbol"><h4>The type void</h4> <br /><p>The type specifier void indicates that no value is available.</p></td>
 
    </tr>
    <tr>
      <td scope="row" data-label="SR. NO">4</td>
      <td data-label="Symbol"><h4>Derived types</h4><br /> <p>They include (a) Pointer types, (b) Array types, (c) Structure types, (d) Union types and (e) Function types.</p></td>
     
    </tr>
   
   
  </tbody>
</table>
<p>The array types and structure types are referred collectively as the aggregate types. The type of a function specifies the type of the function's return value. We will see the basic types in the following
     section, where as other types will be covered in the upcoming chapters.</p> <br />
     <h3>Floating-Point Types</h3> <br />
     <p>The following table provide the details of standard floating-point types with storage sizes and value ranges and their precision −</p> <br />
<table>

  <thead>
    <tr>
      <th scope="col">Type</th>
      <th scope="col">Storage size</th>
      <th scope="col">Value Range</th>
      <th scope="col">Precision</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td data-label="Type">float</td>
      <td data-label="Storage size"> 4 byte </td>
      <td data-label="Value Range">1.2E-38 to 3.4E+38</td>
      <td data-label="Precision">6 decimal places</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type">double </td>
      <td data-label="Storage size">8 byte</td>
      <td data-label="Value Range"> 2.3E-308 to 1.7E+308</td>
      <td data-label="Precision">15 decimal places</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type">long double</td>
      <td data-label="Storage size">10 byte</td>
      <td data-label="Value Range">3.4E-4932 to 1.1E+4932	</td>
      <td data-label="Precision">-19 decimal places </td>
    </tr>
   
   
  </tbody>
</table>
<h3>Integer Types</h3> <br />
<p>The following table provides the details of standard integer types with their storage size sizes and value ranges −</p> <br /><table>

  <thead>
    <tr>
      <th scope="col">Type</th>
      <th scope="col">Storage size</th>
      <th scope="col">Value Range</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td data-label="Type">char</td>
      <td data-label="Storage size"> 1 byte </td>
      <td data-label="Value Range">-128 to 127 or 0 to 255</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type">unsigned char </td>
      <td data-label="Storage size">1 byte</td>
      <td data-label="Value Range"> 0 to 255</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type">signed char</td>
      <td data-label="Storage size">1 byte</td>
      <td data-label="Value Range">-128 to 127 </td>
    </tr>
    <tr>
      <td scope="row" data-label="Type">int</td>
      <td data-label="Storage size">2 or 4 bytes</td>
      <td data-label="Value Range">-32,768 to 32,767 or -2,147,483,648 to 2,147,483,647</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type">unsigned int</td>
      <td data-label="Storage size"> 2 or 4 bytes</td>
      <td data-label="Value Range">0 to 65,535 or 0 to 4,294,967,295</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type">short</td>
      <td data-label="Storage size">2 bytes	</td>
      <td data-label="Value Range">-32,768 to 32,767</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type">unsigned short</td>
      <td data-label="Storage size">2 bytes	</td>
      <td data-label="Value Range">0 to 65,535</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type">long</td>
      <td data-label="Storage size">8 bytes or (4bytes for 32 bit OS)	</td>
      <td data-label="Value Range">-9223372036854775808 to 9223372036854775807</td>
    </tr>
    <tr>
      <td scope="row" data-label="Type">unsigned long	</td>
      <td data-label="Storage size">8 bytes	</td>
      <td data-label="Value Range">0 to 18446744073709551615</td>
    </tr>
  </tbody>
</table>
            </div>
        </div>
    )
}

export default Data
